import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './modules/client/auth/interceptors/auth.interceptor';
import { AuthService } from './modules/client/auth/services/auth.service';
import { adminAuthInterceptor } from './modules/admin/auth/interceptors/admin-auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(withInterceptors([adminAuthInterceptor, authInterceptor])),
    // Restablecer la sesión de Amplify al iniciar la aplicación para que la señal del token esté lista
    // antes de que se active cualquier componente o solicitud HTTP: Amplify lee desde su propio
    // localStorage y actualiza automáticamente el token de acceso si es necesario.
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.loadSessionToken();
    }),
  ]
};

